import React from "react";
import { GiftCardRecieveAPI } from "../../Service/edit_profile";
import * as asyncState from "../../Utils/asyncState";
import "./ReceivedGiftCards.scss";
import { CircularProgress } from "@mui/material";

interface ReceivedGifts extends asyncState.AsyncState {
  data: {}[];
}

function ReceivedGiftCards({
  apply,
  hideEmptyState,
  coupon,
  product = {},
  variant = "profile",
}: any) {
  const [receivedGifts, setReceivedGifts] = React.useState<ReceivedGifts>({
    ...asyncState.initState,
    data: [],
  });

  React.useEffect(() => {
    const getGiftCards = async () => {
      setReceivedGifts({ data: [], ...asyncState.pendingState });

      try {
        let userID: any = localStorage.getItem("Nurture_user_data");
        userID = JSON.parse(userID)?.id;

        let res: any = await GiftCardRecieveAPI({ user_id: userID, ...product });
        setReceivedGifts({ data: res?.data?.data ?? [], ...asyncState.successState });
      } catch (err: any) {
        setReceivedGifts({
          data: [],
          ...asyncState.failedState,
          failedMessage: err?.message,
        });
      }
    };

    getGiftCards();
  }, []);

  const availableGifts = React.useMemo(
    () => receivedGifts.data.filter((gift: any) => gift?.remaining_amount > 0),
    [receivedGifts.data]
  );

  const rootClassName =
    variant === "checkout" ? "ReceivedGiftCards ReceivedGiftCards--checkout" : "ReceivedGiftCards";

  return (
    <div className={rootClassName}>
      {receivedGifts.pending && (
        <div className="receivedGiftCardsCopyMain receivedGiftCardsGiftedFrom">
          <CircularProgress size={24} />
        </div>
      )}

      {!receivedGifts.pending && !availableGifts.length && !hideEmptyState && (
        <div className="receivedGiftCardsEmpty">
          You do not have any available gift cards
        </div>
      )}

      {availableGifts?.map((gift: any) => (
        <div className="receivedGiftCardItem" key={gift.id}>
          <div className="receivedGiftCardsGiftedFrom">
            <span className="receivedGiftCardsSenderName">{gift?.sender_name}</span>{" "}
            <span className="receivedGiftCardsSenderEmail">({gift?.sender_email})</span>{" "}
            <span className="receivedGiftCardsGiftedText">gifted you {gift?.title}</span>
          </div>

          <div className="receivedGiftCardsAmount">
            <div>Total amount: ${gift?.amount}</div>
            <div>Remaining amount: ${gift?.remaining_amount}</div>
          </div>

          <div className="receivedGiftCardsActionRow">
            <input
              type="text"
              value={gift?.code}
              readOnly
              className="form-control receivedGiftCardsCodeInput"
              id={`gift-card-code-${gift?.id}`}
            />

            <button
              type="button"
              className="btn secondary-teal-btn receivedGiftCardsUseBtn"
              onClick={() => apply(gift?.code)}
              disabled={coupon === gift?.code}
            >
              {coupon === gift?.code ? "Applied" : "Use"}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ReceivedGiftCards;
